import { Link as RouterLink } from "react-router-dom";
import { Button, Link as ChakraLink } from "@chakra-ui/react";

type DicomLinkButtonProps = {
  link?: string;
  label?: string;
};

export default function DicomLinkButton({ link, label }: DicomLinkButtonProps) {
  return (
    <Button
    as={ChakraLink}
    href={link}
    isExternal
    colorScheme="blue"
  >
   {label ?? "Dicom画像リンクボタン"}
  </Button>
  );
}